import { render, staticRenderFns } from "./CardInfos.vue?vue&type=template&id=44ba2fca"
import script from "./CardInfos.vue?vue&type=script&lang=js"
export * from "./CardInfos.vue?vue&type=script&lang=js"
import style0 from "./CardInfos.vue?vue&type=style&index=0&id=44ba2fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports